import { render, staticRenderFns } from "./TheCredit.vue?vue&type=template&id=0732c944&"
import script from "./TheCredit.vue?vue&type=script&lang=js&"
export * from "./TheCredit.vue?vue&type=script&lang=js&"
import style0 from "./TheCredit.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports